{
    "name": "winChapter_y4",
    "actionTrace": [
        {
            "type": "invoke skill",
            "skillKey": "inflict-damage",
            "performerKey": "aide",
            "position": {
                "x": 17,
                "y": 7,
                "z": 1
            },
            "performerPosition": {
                "x": 16,
                "y": 6,
                "z": 1
            }
        },
        {
            "type": "invoke skill",
            "skillKey": "inflict-damage",
            "performerKey": "friend",
            "position": {
                "x": 15,
                "y": 8,
                "z": 1
            },
            "performerPosition": {
                "x": 15,
                "y": 6,
                "z": 1
            }
        },
        {
            "type": "move",
            "performerKey": "princess",
            "position": {
                "x": 13,
                "y": 7,
                "z": 1
            },
            "performerPosition": {
                "x": 13,
                "y": 7,
                "z": 1
            },
            "distance": 2
        },
        {
            "type": "move",
            "performerKey": "hero",
            "position": {
                "x": 13,
                "y": 6,
                "z": 1
            },
            "performerPosition": {
                "x": 13,
                "y": 6,
                "z": 1
            },
            "distance": 2
        },
        {
            "type": "invoke skill",
            "skillKey": "rally",
            "performerKey": "princess",
            "position": {
                "x": 13,
                "y": 6,
                "z": 1
            },
            "performerPosition": {
                "x": 13,
                "y": 7,
                "z": 1
            }
        },
        {
            "type": "invoke skill",
            "skillKey": "inflict-damage",
            "performerKey": "hero",
            "position": {
                "x": 12,
                "y": 7,
                "z": 1
            },
            "performerPosition": {
                "x": 12,
                "y": 6,
                "z": 1
            }
        },
        {
            "type": "endTurn"
        },
        {
            "type": "invoke skill",
            "skillKey": "inflict-damage",
            "performerKey": "princess",
            "position": {
                "x": 12,
                "y": 12,
                "z": 1
            },
            "performerPosition": {
                "x": 12,
                "y": 11,
                "z": 1
            }
        },
        {
            "type": "invoke skill",
            "skillKey": "inflict-damage",
            "performerKey": "aide",
            "position": {
                "x": 10,
                "y": 12,
                "z": 1
            },
            "performerPosition": {
                "x": 11,
                "y": 11,
                "z": 1
            }
        },
        {
            "type": "move",
            "performerKey": "friend",
            "position": {
                "x": 12,
                "y": 9,
                "z": 1
            },
            "performerPosition": {
                "x": 12,
                "y": 9,
                "z": 1
            },
            "distance": 2
        },
        {
            "type": "move",
            "performerKey": "hero",
            "position": {
                "x": 12,
                "y": 10,
                "z": 1
            },
            "performerPosition": {
                "x": 12,
                "y": 10,
                "z": 1
            },
            "distance": 2
        },
        {
            "type": "undoAction"
        },
        {
            "type": "invoke skill",
            "skillKey": "smite",
            "performerKey": "hero",
            "position": {
                "x": 12,
                "y": 9,
                "z": 1
            },
            "performerPosition": {
                "x": 13,
                "y": 9,
                "z": 1
            }
        },
        {
            "type": "invoke skill",
            "skillKey": "inflict-damage",
            "performerKey": "friend",
            "position": {
                "x": 9,
                "y": 10,
                "z": 1
            },
            "performerPosition": {
                "x": 10,
                "y": 9,
                "z": 1
            }
        },
        {
            "type": "endTurn"
        },
        {
            "type": "move",
            "performerKey": "friend",
            "position": {
                "x": 12,
                "y": 14,
                "z": 1
            },
            "performerPosition": {
                "x": 12,
                "y": 14,
                "z": 1
            },
            "distance": 2
        },
        {
            "type": "invoke skill",
            "skillKey": "rally",
            "performerKey": "princess",
            "position": {
                "x": 12,
                "y": 14,
                "z": 1
            },
            "performerPosition": {
                "x": 13,
                "y": 14,
                "z": 1
            }
        },
        {
            "type": "invoke skill",
            "skillKey": "inflict-damage",
            "performerKey": "friend",
            "position": {
                "x": 10,
                "y": 16,
                "z": 1
            },
            "performerPosition": {
                "x": 12,
                "y": 16,
                "z": 1
            }
        },
        {
            "type": "move",
            "performerKey": "aide",
            "position": {
                "x": 12,
                "y": 15,
                "z": 1
            },
            "performerPosition": {
                "x": 12,
                "y": 15,
                "z": 1
            },
            "distance": 2
        },
        {
            "type": "endTurn"
        },
        {
            "type": "invoke skill",
            "skillKey": "inflict-damage",
            "performerKey": "aide",
            "position": {
                "x": 10,
                "y": 16,
                "z": 1
            },
            "performerPosition": {
                "x": 11,
                "y": 15,
                "z": 1
            }
        },
        {
            "type": "invoke skill",
            "skillKey": "inflict-damage",
            "performerKey": "hero",
            "position": {
                "x": 11,
                "y": 13,
                "z": 1
            },
            "performerPosition": {
                "x": 12,
                "y": 13,
                "z": 1
            }
        },
        {
            "type": "invoke skill",
            "skillKey": "rally",
            "performerKey": "princess",
            "position": {
                "x": 12,
                "y": 13,
                "z": 1
            },
            "performerPosition": {
                "x": 12,
                "y": 14,
                "z": 1
            }
        },
        {
            "type": "undoAction"
        },
        {
            "type": "invoke skill",
            "skillKey": "rally",
            "performerKey": "princess",
            "position": {
                "x": 12,
                "y": 13,
                "z": 1
            },
            "performerPosition": {
                "x": 13,
                "y": 13,
                "z": 1
            }
        },
        {
            "type": "move",
            "performerKey": "hero",
            "position": {
                "x": 11,
                "y": 14,
                "z": 1
            },
            "performerPosition": {
                "x": 11,
                "y": 14,
                "z": 1
            },
            "distance": 2
        },
        {
            "type": "undoAction"
        },
        {
            "type": "undoAction"
        },
        {
            "type": "move",
            "performerKey": "friend",
            "position": {
                "x": 12,
                "y": 14,
                "z": 1
            },
            "performerPosition": {
                "x": 12,
                "y": 14,
                "z": 1
            },
            "distance": 2
        },
        {
            "type": "invoke skill",
            "skillKey": "rally",
            "performerKey": "princess",
            "position": {
                "x": 12,
                "y": 14,
                "z": 1
            },
            "performerPosition": {
                "x": 13,
                "y": 14,
                "z": 1
            }
        },
        {
            "type": "invoke skill",
            "skillKey": "inflict-damage",
            "performerKey": "friend",
            "position": {
                "x": 9,
                "y": 14,
                "z": 1
            },
            "performerPosition": {
                "x": 11,
                "y": 14,
                "z": 1
            }
        },
        {
            "type": "endTurn"
        },
        {
            "type": "invoke skill",
            "skillKey": "inflict-damage",
            "performerKey": "friend",
            "position": {
                "x": 8,
                "y": 17,
                "z": 1
            },
            "performerPosition": {
                "x": 10,
                "y": 17,
                "z": 1
            }
        },
        {
            "type": "move",
            "performerKey": "aide",
            "position": {
                "x": 12,
                "y": 18,
                "z": 1
            },
            "performerPosition": {
                "x": 12,
                "y": 18,
                "z": 1
            },
            "distance": 2
        },
        {
            "type": "invoke skill",
            "skillKey": "smite",
            "performerKey": "hero",
            "position": {
                "x": 12,
                "y": 18,
                "z": 1
            },
            "performerPosition": {
                "x": 13,
                "y": 18,
                "z": 1
            }
        },
        {
            "type": "undoAction"
        },
        {
            "type": "undoAction"
        },
        {
            "type": "move",
            "performerKey": "aide",
            "position": {
                "x": 13,
                "y": 18,
                "z": 1
            },
            "performerPosition": {
                "x": 13,
                "y": 18,
                "z": 1
            },
            "distance": 1
        },
        {
            "type": "invoke skill",
            "skillKey": "smite",
            "performerKey": "hero",
            "position": {
                "x": 13,
                "y": 18,
                "z": 1
            },
            "performerPosition": {
                "x": 14,
                "y": 18,
                "z": 1
            }
        },
        {
            "type": "invoke skill",
            "skillKey": "inflict-damage",
            "performerKey": "aide",
            "position": {
                "x": 11,
                "y": 20,
                "z": 1
            },
            "performerPosition": {
                "x": 11,
                "y": 18,
                "z": 1
            }
        },
        {
            "type": "invoke skill",
            "skillKey": "rally",
            "performerKey": "princess",
            "position": {
                "x": 14,
                "y": 18,
                "z": 1
            },
            "performerPosition": {
                "x": 13,
                "y": 18,
                "z": 1
            }
        },
        {
            "type": "move",
            "performerKey": "hero",
            "position": {
                "x": 12,
                "y": 18,
                "z": 1
            },
            "performerPosition": {
                "x": 12,
                "y": 18,
                "z": 1
            },
            "distance": 2
        },
        {
            "type": "endTurn"
        },
        {
            "type": "invoke skill",
            "skillKey": "inflict-damage",
            "performerKey": "friend",
            "position": {
                "x": 10,
                "y": 19,
                "z": 1
            },
            "performerPosition": {
                "x": 10,
                "y": 17,
                "z": 1
            }
        },
        {
            "type": "invoke skill",
            "skillKey": "inflict-damage",
            "performerKey": "hero",
            "position": {
                "x": 10,
                "y": 19,
                "z": 1
            },
            "performerPosition": {
                "x": 11,
                "y": 19,
                "z": 1
            }
        },
        {
            "type": "endTurn"
        },
        {
            "type": "invoke skill",
            "skillKey": "inflict-damage",
            "performerKey": "hero",
            "position": {
                "x": 11,
                "y": 23,
                "z": 1
            },
            "performerPosition": {
                "x": 12,
                "y": 23,
                "z": 1
            }
        },
        {
            "type": "invoke skill",
            "skillKey": "inflict-damage",
            "performerKey": "friend",
            "position": {
                "x": 13,
                "y": 24,
                "z": 1
            },
            "performerPosition": {
                "x": 13,
                "y": 22,
                "z": 1
            }
        },
        {
            "type": "invoke skill",
            "skillKey": "rally",
            "performerKey": "princess",
            "position": {
                "x": 12,
                "y": 23,
                "z": 1
            },
            "performerPosition": {
                "x": 11,
                "y": 23,
                "z": 1
            }
        },
        {
            "type": "invoke skill",
            "skillKey": "inflict-damage",
            "performerKey": "hero",
            "position": {
                "x": 14,
                "y": 24,
                "z": 1
            },
            "performerPosition": {
                "x": 14,
                "y": 23,
                "z": 1
            }
        },
        {
            "type": "move",
            "performerKey": "aide",
            "position": {
                "x": 13,
                "y": 21,
                "z": 1
            },
            "performerPosition": {
                "x": 13,
                "y": 21,
                "z": 1
            },
            "distance": 1
        },
        {
            "type": "endTurn"
        },
        {
            "type": "invoke skill",
            "skillKey": "inflict-damage",
            "performerKey": "hero",
            "position": {
                "x": 15,
                "y": 24,
                "z": 1
            },
            "performerPosition": {
                "x": 14,
                "y": 24,
                "z": 1
            }
        },
        {
            "type": "invoke skill",
            "skillKey": "inflict-damage",
            "performerKey": "friend",
            "position": {
                "x": 16,
                "y": 23,
                "z": 1
            },
            "performerPosition": {
                "x": 15,
                "y": 22,
                "z": 1
            }
        },
        {
            "type": "invoke skill",
            "skillKey": "inflict-damage",
            "performerKey": "princess",
            "position": {
                "x": 11,
                "y": 24,
                "z": 1
            },
            "performerPosition": {
                "x": 12,
                "y": 24,
                "z": 1
            }
        },
        {
            "type": "move",
            "performerKey": "aide",
            "position": {
                "x": 13,
                "y": 23,
                "z": 1
            },
            "performerPosition": {
                "x": 13,
                "y": 23,
                "z": 1
            },
            "distance": 2
        },
        {
            "type": "endTurn"
        },
        {
            "type": "invoke skill",
            "skillKey": "inflict-damage",
            "performerKey": "friend",
            "position": {
                "x": 15,
                "y": 23,
                "z": 1
            },
            "performerPosition": {
                "x": 14,
                "y": 22,
                "z": 1
            }
        },
        {
            "type": "endTurn"
        }
    ],
    "deltastageSum": {
        "units": {
            "princess": {
                "key": "princess",
                "jobKey": "sword",
                "affiliation": "good",
                "isRecruited": true,
                "maxhealth": 50,
                "moverange": 2,
                "skills": [
                    "inflict-damage",
                    "rally",
                    "recruit"
                ],
                "name": "PRINCESS",
                "faceKey": "human",
                "bodyKey": "good",
                "dialogue": {
                    "death": "Damn."
                },
                "portraits": {
                    "neutral": "./RP-neutral2-ZK5JV6ZJ.png",
                    "angry": "./RP-angry-AJ6PJQEY.png",
                    "happy": "./RP-happy-HEYINXAH.png"
                },
                "position": {
                    "mode": "absolute",
                    "x": 12,
                    "y": 24,
                    "z": 1
                },
                "spawnspot": {
                    "key": "7zYikdnEPbmSrYxhkpb9v",
                    "isDead": false,
                    "position": {
                        "x": 13,
                        "y": 5,
                        "z": 1
                    },
                    "affiliation": "none",
                    "skills": [
                        null
                    ],
                    "equippedSkills": {},
                    "energy": {
                        "move": true,
                        "invoke skill": true
                    },
                    "health": 5,
                    "maxhealth": 5,
                    "effects": {},
                    "inventory": {
                        "items": {}
                    },
                    "armor": 0,
                    "maxarmor": 0,
                    "state": "aggroed",
                    "type": "spot"
                },
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    },
                    "key": {
                        "0": "p",
                        "1": "r",
                        "2": "i",
                        "3": "n",
                        "4": "c",
                        "5": "e",
                        "6": "s",
                        "7": "s"
                    }
                },
                "experience": 120,
                "health": 20,
                "state": "aggroed",
                "isDead": false,
                "hasBeenRemoved": false
            },
            "hero": {
                "key": "hero",
                "jobKey": "hammer",
                "aliases": [
                    "Himmel",
                    "paladin",
                    "Masked Man"
                ],
                "affiliation": "good",
                "isRecruited": true,
                "maxhealth": 50,
                "skills": [
                    "inflict-damage",
                    "smite",
                    "recruit"
                ],
                "name": "HERO",
                "faceKey": "human",
                "bodyKey": "good",
                "dialogue": {
                    "death": "Damn."
                },
                "position": {
                    "mode": "absolute",
                    "x": 14,
                    "y": 24,
                    "z": 1
                },
                "spawnspot": {
                    "key": "3UwFFgJt2SglcBNuMqtb9",
                    "isDead": false,
                    "position": {
                        "x": 14,
                        "y": 5,
                        "z": 1
                    },
                    "affiliation": "none",
                    "skills": [
                        null
                    ],
                    "equippedSkills": {},
                    "energy": {
                        "move": true,
                        "invoke skill": true
                    },
                    "health": 5,
                    "maxhealth": 5,
                    "effects": {},
                    "inventory": {
                        "items": {}
                    },
                    "armor": 0,
                    "maxarmor": 0,
                    "state": "aggroed",
                    "type": "spot"
                },
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    },
                    "key": {
                        "0": "h",
                        "1": "e",
                        "2": "r",
                        "3": "o"
                    }
                },
                "experience": 140,
                "isDead": false,
                "health": 5,
                "hasBeenRemoved": false,
                "state": "aggroed"
            },
            "friend": {
                "key": "friend",
                "jobKey": "bow",
                "affiliation": "good",
                "isRecruited": true,
                "maxhealth": 40,
                "skills": [
                    "inflict-damage",
                    "pull",
                    "recruit"
                ],
                "name": "FRIEND",
                "faceKey": "human",
                "bodyKey": "good",
                "dialogue": {
                    "death": "Damn."
                },
                "position": {
                    "mode": "absolute",
                    "x": 14,
                    "y": 22,
                    "z": 1
                },
                "spawnspot": {
                    "key": "sDPpT_R4jd-wH0akDMt7R",
                    "isDead": false,
                    "position": {
                        "x": 15,
                        "y": 5,
                        "z": 1
                    },
                    "affiliation": "none",
                    "skills": [
                        null
                    ],
                    "equippedSkills": {},
                    "energy": {
                        "move": true,
                        "invoke skill": true
                    },
                    "health": 5,
                    "maxhealth": 5,
                    "effects": {},
                    "inventory": {
                        "items": {}
                    },
                    "armor": 0,
                    "maxarmor": 0,
                    "state": "aggroed",
                    "type": "spot"
                },
                "experience": 190,
                "energy": {
                    "key": {
                        "0": "f",
                        "1": "r",
                        "2": "i",
                        "3": "e",
                        "4": "n",
                        "5": "d"
                    },
                    "energy": {
                        "move": false,
                        "invoke skill": false
                    }
                },
                "isDead": false,
                "health": 20,
                "hasBeenRemoved": false,
                "state": "aggroed"
            },
            "aide": {
                "key": "aide",
                "jobKey": "dagger",
                "affiliation": "good",
                "isRecruited": true,
                "maxhealth": 40,
                "skills": [
                    "inflict-damage",
                    "swap",
                    "recruit"
                ],
                "name": "AIDE",
                "faceKey": "human",
                "bodyKey": "good",
                "dialogue": {
                    "death": "Damn."
                },
                "position": {
                    "mode": "absolute",
                    "x": 13,
                    "y": 23,
                    "z": 1
                },
                "spawnspot": {
                    "key": "FpfoC3N8dFfZxcJz4bUSP",
                    "isDead": false,
                    "position": {
                        "x": 16,
                        "y": 5,
                        "z": 1
                    },
                    "affiliation": "none",
                    "skills": [
                        null
                    ],
                    "equippedSkills": {},
                    "energy": {
                        "move": true,
                        "invoke skill": true
                    },
                    "health": 5,
                    "maxhealth": 5,
                    "effects": {},
                    "inventory": {
                        "items": {}
                    },
                    "armor": 0,
                    "maxarmor": 0,
                    "state": "aggroed",
                    "type": "spot"
                },
                "experience": 80,
                "energy": {
                    "key": {
                        "0": "a",
                        "1": "i",
                        "2": "d",
                        "3": "e"
                    },
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                },
                "isDead": false,
                "health": 40,
                "hasBeenRemoved": false
            },
            "h8dVVeMG5TiNIbxDEmSRD": {
                "key": "h8dVVeMG5TiNIbxDEmSRD",
                "health": 0,
                "position": {
                    "mode": "absolute",
                    "x": 17,
                    "y": 7,
                    "z": 1
                },
                "state": "aggroed",
                "opacity": 0,
                "isDead": true,
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "pV8dL00d6Wuo5OJA_Scw7": {
                "key": "pV8dL00d6Wuo5OJA_Scw7",
                "health": 0,
                "position": {
                    "mode": "absolute",
                    "x": 15,
                    "y": 8,
                    "z": 1
                },
                "state": "aggroed",
                "opacity": 0,
                "isDead": true,
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "DNuKEAd5dtbnfz4salwRT": {
                "key": "DNuKEAd5dtbnfz4salwRT",
                "health": 0,
                "position": {
                    "mode": "absolute",
                    "x": 12,
                    "y": 7,
                    "z": 1
                },
                "state": "aggroed",
                "opacity": 0,
                "isDead": true,
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "AUGaHEoj_xzqAz0rBtIfl": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "PxJfDDzLcAXKEsPGryl2s": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "pgbTxRKoRzdYpacUnH8uH": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "4phu_YP-1F8ebFCRQ1JoO": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "lwV3qBuvfYiCaNiOJqjuh": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "IaGnljI2L0n8SJuLsFf-8": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "7zYikdnEPbmSrYxhkpb9v": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "3UwFFgJt2SglcBNuMqtb9": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "sDPpT_R4jd-wH0akDMt7R": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "FpfoC3N8dFfZxcJz4bUSP": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "4mfQ_5sUTuY2-bp5giwjo": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "qk7tQjK0jjVt0L2H4-Kq6": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "gfcyTIkVdHgs-e0h7-j_D": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "iW9xe0m8nt4trd3r7m_vc": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "cYfuVuDsJzjUqC-wmqrMO": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "eobBX2V4EiOkvMQQ0knwq": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "8INMzGuFMABK-MYct4tYs": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "8nwT_tuDf_PiN7pVy0Z9X": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "ttCoNsjOtYO1VF7_cAjEy": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "Wberb-tM5cA4Zi2QMNRme": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "751ixa8EB_X5XFigg4-kx": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "prSOnEDzd49BDfzq76vyo": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "Pln-AryJbEUDAiG2mwugc": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "yyjyDYdMrc_8vDYIaWv35": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "YqV9eNLP_7P4y9y0KNYwD": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "MUpSYd6nebh7an1cIzHFP": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "kwQ2YQ3z0WxDJac8oWVub": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "oiPH3oHEkmnyVlcgNkl8u": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "k6UBRgVCU5reO2a63AFWA": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "YIAJ-ldLpkQqvtjTqvYAi": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "d-oI4h3Cbu7BIf9x3ViVF": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "GEvwqdfrWIaWGz3tNxJdX": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "TMrBaAspEKTvKdzLGB2jJ": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "1yEqKsTtPcKGBnDMJVvPN": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "wiTr5SuVf9RoNvm7BBVci": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "xYZBUcaJuHx9VoNGgxe_T": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "_rrjmIHvpssZI4LBFOI-V": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "gBiYHfKL5p7SyQsEboOFs": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "BvtIv7YuH8D-_qn5hv9GU": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    },
                    "key": {
                        "0": "B",
                        "1": "v",
                        "2": "t",
                        "3": "I",
                        "4": "v",
                        "5": "7",
                        "6": "Y",
                        "7": "u",
                        "8": "H",
                        "9": "8",
                        "10": "D",
                        "11": "-",
                        "12": "_",
                        "13": "q",
                        "14": "n",
                        "15": "5",
                        "16": "h",
                        "17": "v",
                        "18": "9",
                        "19": "G",
                        "20": "U"
                    }
                },
                "key": "BvtIv7YuH8D-_qn5hv9GU",
                "position": {
                    "mode": "absolute",
                    "x": 13,
                    "y": 8,
                    "z": 1
                },
                "experience": 10,
                "health": 0,
                "state": "aggroed",
                "opacity": 0,
                "isDead": true
            },
            "UicFwyDNNcFxhyxFRWjpp": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                },
                "key": "UicFwyDNNcFxhyxFRWjpp",
                "health": 0,
                "position": {
                    "mode": "absolute",
                    "x": 9,
                    "y": 10,
                    "z": 1
                },
                "state": "aggroed",
                "opacity": 0,
                "isDead": true
            },
            "g5_bFB4nY9LfaEuWi-1in": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                },
                "key": "g5_bFB4nY9LfaEuWi-1in",
                "health": 0,
                "position": {
                    "mode": "absolute",
                    "x": 10,
                    "y": 12,
                    "z": 1
                },
                "state": "aggroed",
                "opacity": 0,
                "isDead": true
            },
            "jPLVGjZ5bEVft7M0usxlg": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                },
                "key": "jPLVGjZ5bEVft7M0usxlg",
                "health": 0,
                "position": {
                    "mode": "absolute",
                    "x": 12,
                    "y": 12,
                    "z": 1
                },
                "state": "aggroed",
                "opacity": 0,
                "isDead": true
            },
            "sczuyEy6_0hU-Nn6Nj5O2": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "6BQB5CwldyMxPROCKogEY": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "pkT3jbBKDYK3yFQo3lQoZ": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "5jBu_0kU0ZuI15to0hUnR": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                },
                "key": "5jBu_0kU0ZuI15to0hUnR",
                "position": {
                    "mode": "absolute",
                    "x": 11,
                    "y": 13,
                    "z": 1
                },
                "health": 0,
                "state": "aggroed",
                "opacity": 0,
                "isDead": true
            },
            "T5QoTW-sivLiPsIxALx3i": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                },
                "key": "T5QoTW-sivLiPsIxALx3i",
                "position": {
                    "mode": "absolute",
                    "x": 9,
                    "y": 14,
                    "z": 1
                },
                "health": 0,
                "state": "aggroed",
                "opacity": 0,
                "isDead": true
            },
            "Ka5mMBpKbS9HCA5owcgvQ": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                },
                "key": "Ka5mMBpKbS9HCA5owcgvQ",
                "position": {
                    "mode": "absolute",
                    "x": 10,
                    "y": 16,
                    "z": 1
                },
                "health": 0,
                "state": "aggroed",
                "opacity": 0,
                "isDead": true
            },
            "1pcUsVzKxaJg7I3OOsgk2": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                },
                "key": "1pcUsVzKxaJg7I3OOsgk2",
                "health": 0,
                "position": {
                    "mode": "absolute",
                    "x": 10,
                    "y": 16,
                    "z": 1
                },
                "state": "aggroed",
                "opacity": 0,
                "isDead": true
            },
            "vgo_9wwegF8wd1-PZ-d1m": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "nDN9zK1deBxbfXq9DxjRG": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "YQ_C-bElFE8RtaWeXSH1g": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "F0crVZxGs57zQRwzwRAYi": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "s4rFXrTW76yNTPhw0_UG_": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                },
                "key": "s4rFXrTW76yNTPhw0_UG_",
                "position": {
                    "mode": "absolute",
                    "x": 10,
                    "y": 19,
                    "z": 1
                },
                "health": 0,
                "state": "aggroed",
                "opacity": 0,
                "isDead": true
            },
            "a8YSMl0lZMDjKOHSAfUng": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "mSsvrCt8xAHs9VMKY-HYq": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "N4VN2kmE2sgjgNlnik-oF": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "LM_xVTIugKKSIbFt7pcCR": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "TbXIl6w7ih7jjN-yoL1il": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "8Qw21l3tfCXjDqypZ0_Yp": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "nII3UBtf7h8_FbczBMY7f": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "IZn-4FnIe7PUyQCTilvdq": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "0KVp1SeyVSzw7IWyXA1VA": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "IvYBJipPxSnEgtlPFq7ey": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "FdjHvvRWAiMG1UNj6CirR": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "G4CwaOY-nXyAYplJOu6NI": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "PevBCNwkqTa-nGxAU3ais": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "xLqVHRCrr9W5xChF1ZopK": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "6p0MnSxBEBdtvhs-cpVze": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "ijLmmX_QE5_n6NDt-bQhL": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                },
                "key": "ijLmmX_QE5_n6NDt-bQhL",
                "health": 0,
                "position": {
                    "mode": "absolute",
                    "x": 8,
                    "y": 17,
                    "z": 1
                },
                "state": "aggroed",
                "opacity": 0,
                "isDead": true
            },
            "WTz96NrphJEEW0id5SeWO": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                },
                "key": "WTz96NrphJEEW0id5SeWO",
                "health": 0,
                "position": {
                    "mode": "absolute",
                    "x": 11,
                    "y": 20,
                    "z": 1
                },
                "state": "aggroed",
                "opacity": 0,
                "isDead": true
            },
            "Gx4_Fblg_aAxgsYZMiFjd": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "ad96JUzuYkjAJckAOLbnP": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                }
            },
            "L-7fXjioI6QLOCGKXQcDH": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                },
                "key": "L-7fXjioI6QLOCGKXQcDH",
                "health": 0,
                "position": {
                    "mode": "absolute",
                    "x": 11,
                    "y": 23,
                    "z": 1
                },
                "state": "aggroed",
                "opacity": 0,
                "isDead": true
            },
            "mL5aTaUpSDcyUlksVUB8S": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                },
                "key": "mL5aTaUpSDcyUlksVUB8S",
                "health": 0,
                "position": {
                    "mode": "absolute",
                    "x": 13,
                    "y": 24,
                    "z": 1
                },
                "state": "aggroed",
                "opacity": 0,
                "isDead": true
            },
            "cvwh-CbB-sbPLMUU19kD7": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    },
                    "key": {
                        "0": "c",
                        "1": "v",
                        "2": "w",
                        "3": "h",
                        "4": "-",
                        "5": "C",
                        "6": "b",
                        "7": "B",
                        "8": "-",
                        "9": "s",
                        "10": "b",
                        "11": "P",
                        "12": "L",
                        "13": "M",
                        "14": "U",
                        "15": "U",
                        "16": "1",
                        "17": "9",
                        "18": "k",
                        "19": "D",
                        "20": "7"
                    }
                },
                "key": "cvwh-CbB-sbPLMUU19kD7",
                "position": {
                    "mode": "absolute",
                    "x": 11,
                    "y": 24,
                    "z": 1
                },
                "experience": 10,
                "health": 0,
                "state": "aggroed",
                "opacity": 0,
                "isDead": true
            },
            "wqXLdnVaTMug7w3SpveNq": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                },
                "key": "wqXLdnVaTMug7w3SpveNq",
                "health": 0,
                "position": {
                    "mode": "absolute",
                    "x": 14,
                    "y": 24,
                    "z": 1
                },
                "state": "aggroed",
                "opacity": 0,
                "isDead": true
            },
            "4vZkaR0ymtsbqfbEBricC": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    },
                    "key": {
                        "0": "4",
                        "1": "v",
                        "2": "Z",
                        "3": "k",
                        "4": "a",
                        "5": "R",
                        "6": "0",
                        "7": "y",
                        "8": "m",
                        "9": "t",
                        "10": "s",
                        "11": "b",
                        "12": "q",
                        "13": "f",
                        "14": "b",
                        "15": "E",
                        "16": "B",
                        "17": "r",
                        "18": "i",
                        "19": "c",
                        "20": "C"
                    }
                },
                "key": "4vZkaR0ymtsbqfbEBricC",
                "position": {
                    "mode": "absolute",
                    "x": 13,
                    "y": 24,
                    "z": 1
                },
                "experience": 10,
                "health": 0,
                "state": "aggroed",
                "opacity": 0,
                "isDead": true
            },
            "Z-wdifLSUpYLXev31Uq0v": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    },
                    "key": {
                        "0": "Z",
                        "1": "-",
                        "2": "w",
                        "3": "d",
                        "4": "i",
                        "5": "f",
                        "6": "L",
                        "7": "S",
                        "8": "U",
                        "9": "p",
                        "10": "Y",
                        "11": "L",
                        "12": "X",
                        "13": "e",
                        "14": "v",
                        "15": "3",
                        "16": "1",
                        "17": "U",
                        "18": "q",
                        "19": "0",
                        "20": "v"
                    }
                },
                "key": "Z-wdifLSUpYLXev31Uq0v",
                "position": {
                    "mode": "absolute",
                    "x": 15,
                    "y": 24,
                    "z": 1
                },
                "experience": 10,
                "health": 0,
                "state": "aggroed",
                "opacity": 0,
                "isDead": true
            },
            "rWI8yc2B-ks1b5Uk_l4sK": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    }
                },
                "key": "rWI8yc2B-ks1b5Uk_l4sK",
                "position": {
                    "mode": "absolute",
                    "x": 16,
                    "y": 23,
                    "z": 1
                },
                "health": 0,
                "state": "aggroed",
                "opacity": 0,
                "isDead": true
            },
            "wGt9QheGnNj17e0M4l1iu": {
                "energy": {
                    "energy": {
                        "1": true,
                        "2": true,
                        "move": true,
                        "invoke skill": true,
                        "hasActedOnce": false,
                        "invokeCount": 0
                    },
                    "key": {
                        "0": "w",
                        "1": "G",
                        "2": "t",
                        "3": "9",
                        "4": "Q",
                        "5": "h",
                        "6": "e",
                        "7": "G",
                        "8": "n",
                        "9": "N",
                        "10": "j",
                        "11": "1",
                        "12": "7",
                        "13": "e",
                        "14": "0",
                        "15": "M",
                        "16": "4",
                        "17": "l",
                        "18": "1",
                        "19": "i",
                        "20": "u"
                    }
                },
                "key": "wGt9QheGnNj17e0M4l1iu",
                "position": {
                    "mode": "absolute",
                    "x": 15,
                    "y": 23,
                    "z": 1
                },
                "experience": 10,
                "health": 0,
                "state": "aggroed",
                "opacity": 0,
                "isDead": true
            }
        },
        "audio": {
            "triggerKey": "Unit:Death"
        },
        "type": "particle",
        "text": {
            "string": "EFFECTIVE",
            "font": "numbers"
        },
        "opacity": 0,
        "flags": {
            "tutorial:hasAttacked": true,
            "tutorial:hasAttackedRedWithRed": true,
            "tutorial:AttackerColor": "blue",
            "tutorial:AttackedColor": "red",
            "tutorial:hasKilled": true,
            "tutorial:hasAttackedWithoutCounterattack": true,
            "tutorial:hasRallied": true,
            "tutorial:hasAttackedBlueWithBlue": true,
            "tutorial:hasBeenAttacked": true,
            "tutorial:hasAttackedGreenWithGreen": true,
            "tutorial:hasAttackedIneffectivelyWithEarth": true,
            "tutorial:hasAttackedIneffectively": true
        },
        "turn": {
            "affiliation": "good",
            "number": 4,
            "phase": "end"
        },
        "currentEncounterKey": 5,
        "intent": {
            "type": "reposition",
            "positions": [
                {
                    "x": 13,
                    "y": 18,
                    "z": 1
                },
                {
                    "x": 12,
                    "y": 18,
                    "z": 1
                },
                {
                    "x": 11,
                    "y": 18,
                    "z": 1
                }
            ]
        }
    },
    "sequenceLengthRemaining": 25,
    "chapterSlug": "y4",
    "player": {
        "affiliation": "good",
        "inventory": {
            "gold": 0
        },
        "party": {
            "units": {
                "princess": {
                    "key": "princess",
                    "jobKey": "sword",
                    "affiliation": "good",
                    "isRecruited": true,
                    "maxhealth": 50,
                    "moverange": 2,
                    "skills": [
                        "inflict-damage",
                        "rally",
                        "recruit"
                    ],
                    "name": "PRINCESS",
                    "faceKey": "human",
                    "bodyKey": "good",
                    "dialogue": {
                        "death": "Damn."
                    },
                    "portraits": {
                        "neutral": "./RP-neutral2-ZK5JV6ZJ.png",
                        "angry": "./RP-angry-AJ6PJQEY.png",
                        "happy": "./RP-happy-HEYINXAH.png"
                    }
                },
                "hero": {
                    "key": "hero",
                    "jobKey": "hammer",
                    "aliases": [
                        "Himmel",
                        "paladin",
                        "Masked Man"
                    ],
                    "affiliation": "good",
                    "isRecruited": true,
                    "maxhealth": 50,
                    "skills": [
                        "inflict-damage",
                        "smite",
                        "recruit"
                    ],
                    "name": "HERO",
                    "faceKey": "human",
                    "bodyKey": "good",
                    "dialogue": {
                        "death": "Damn."
                    }
                },
                "friend": {
                    "key": "friend",
                    "jobKey": "bow",
                    "affiliation": "good",
                    "isRecruited": true,
                    "maxhealth": 40,
                    "skills": [
                        "inflict-damage",
                        "pull",
                        "recruit"
                    ],
                    "name": "FRIEND",
                    "faceKey": "human",
                    "bodyKey": "good",
                    "dialogue": {
                        "death": "Damn."
                    }
                },
                "aide": {
                    "key": "aide",
                    "jobKey": "dagger",
                    "affiliation": "good",
                    "isRecruited": true,
                    "maxhealth": 40,
                    "skills": [
                        "inflict-damage",
                        "swap",
                        "recruit"
                    ],
                    "name": "AIDE",
                    "faceKey": "human",
                    "bodyKey": "good",
                    "dialogue": {
                        "death": "Damn."
                    }
                }
            }
        }
    },
    "gameSlug": "war",
    "randomSeed": "qCvICEN4r6x0At8uPTAln",
    "captureDate": 1738624462831,
    "data": {}
}